import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import LOOKUP from 'constants/lookup';
import { clearInventoryFlag } from 'actions/EntityActions';
// Basic Components
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose'
import Button from 'screens/components/basic/Button';
// Advanced Components
import GenericTable from 'screens/components/advanced/GenericTable';
import DialogInput from 'screens/components/advanced/DialogInput';


const dialogStyle = {
    width: '65%',
    maxWidth: 'none'
};
class InventoryFlagDialog extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dialog: true
        };
    }

    clearInventoryFlag = (productId) => {
        this.props.clearInventoryFlag(this.props.branchId, productId);
    }

    render() {
        const { t } = this.props;
        const p = this.props;
        let inventoryFlags = p.inventoryFlags.map((item, index) => {
            return {
                SKU: item.sku,
                Name: item.name,
                TotalQuantity: item.totalQuantity,
                Icons: (
                    <Button
                        key={index}
                        name="buttonClose"
                        primary={true}
                        label={t('common.confirmUpper')}
                        mini={true}
                        onTouchTap={() => this.clearInventoryFlag(item.productId)} />
                )
            };
        });

        return (
            <DialogInput
                title={<DialogHeaderWithClose text={t('pos.inventoryFlagDialog.inventoryFlags')} handleClose={() => this.props.onClose()}/>}
                modal={true}
                open={p.open && this.state.dialog}
                autoScrollBodyContent={true}
                style={{ zIndex: '980' }}
                actions={[
                    <Button
                        key={1}
                        type="CancelButton"
                        name="buttonClose"
                        className="btn-space"
                        label={t('common.close')}
                        onTouchTap={() => this.props.onClose()} />]}
                contentStyle={dialogStyle}>
                <div className="row">
                    <div className="col-lg-12">
                        <p className="alert alert-warning">
                        {t('pos.inventoryFlagDialog.inventoryWarning')}
                        </p>
                    </div>
                    <div className="col-lg-12">
                        <GenericTable
                            compName="recentOrdersListTable"
                            className="recent-orders tableHeaderTxt"
                            adjustForCheckbox={false}
                            displaySelectAll={false}
                            displayRowCheckbox={false}
                            enableSelectAll={false}
                            multiSelectable={false}
                            selectable={false}
                            stripedRows={true}
                            columns={
                                [
                                    { key: "SKU", label: t("pos.productDetails.sku"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                    { key: "Name", label: t("common.name"), visibleMode: "visible-lg" },
                                    { key: "TotalQuantity", label: t("constants.totalQuantity"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                    { key: "Icons", label: "", visibleMode: "visible-lg visible-xs visible-sm visible-md" }
                                  ]
                            }
                            rows={inventoryFlags} />
                    </div>
                </div>
            </DialogInput>
        );
    }
}

function mapStateToProps(state) {
    return {
        inventoryFlags: state.entity.inventoryFlags || [],
        branchId: state.common.branchId,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clearInventoryFlag: (branchId, productId) => dispatch(clearInventoryFlag(branchId, productId))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(InventoryFlagDialog));
